import { assert } from '@ember/debug';
import $ from 'jquery';
export const clipboardMocks = {
  copy($element) {
    return new Promise((resolve, reject) => {
      const element = $($element).get(0); // eslint-disable-line ember/no-jquery

      const isValidElement = element && ['input', 'textarea'].includes(element.tagName.toLowerCase());
      assert('An input or textarea element must be passed to copy.', isValidElement);
      try {
        element.select();
        // IE requires a selection range, rather than select.
        element.setSelectionRange(0, element.value.length);
        document.execCommand('copy');
        element.blur();
        document.getSelection().removeAllRanges();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
};

// This method will copy text within an input or textarea element to
// the clipboard. It must be triggered by a click action, otherwise
// browsers will not allow the execCommand to copy for security.
//
// Implementation borrowed from https://github.com/zenorocha/clipboard.js.
export function copy($element) {
  return clipboardMocks.copy($element);
}